import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function BoilerSVG({ config = {}, width = 70, height = 100, liveValues = {} }) {
    const running = parseFloat(liveValues.state ?? 1) >= parseFloat(config.threshold ?? 0.5);
    const hasError = liveValues.error === 1 || liveValues.error === true ||
        liveValues.error === '1' || liveValues.error === 'true';
    const statusColor = hasError ? '#EF4444' : running ? '#22C55E' : '#64748B';

    const bodyX = 8;
    const bodyY = 12;
    const bodyW = width - 16;
    const bodyH = height - 30;

    const pressureBound = liveValues.pressure != null;
    const tempBound = liveValues.temp != null;
    const pressureVal = parseFloat(liveValues.pressure ?? 0);
    const tempVal = parseFloat(liveValues.temp ?? 0);

    // Flame colors
    const flameColor = running ? '#F97316' : '#475569';
    const flameInner = running ? '#FCD34D' : '#334155';

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Steam outlet stub at top */}
            <rect x={bodyX + bodyW / 2 - 4} y={0} width={8} height={bodyY} rx={2} fill="#94A3B8" />

            {/* Steam waves when running */}
            {running && (
                <>
                    <path d={`M${bodyX + bodyW / 2 - 6},${bodyY - 2} q3,-4 6,0 q3,4 6,0`}
                        fill="none" stroke="#CBD5E1" strokeWidth={1.5} opacity={0.7}>
                        <animate attributeName="opacity" values="0.7;0.2;0.7" dur="1.5s" repeatCount="indefinite" />
                    </path>
                </>
            )}

            {/* Body (pressure vessel) */}
            <rect x={bodyX} y={bodyY} width={bodyW} height={bodyH} rx={6}
                fill="#1E293B" stroke={statusColor} strokeWidth={2} />

            {/* Error flash */}
            {hasError && (
                <rect x={bodyX} y={bodyY} width={bodyW} height={bodyH} rx={6}
                    fill="none" stroke="#EF4444" strokeWidth={3}>
                    <animate attributeName="stroke-opacity" values="1;0;1" dur="0.6s" repeatCount="indefinite" />
                </rect>
            )}

            {/* Pressure / temp text */}
            {pressureBound && (
                <text x={bodyX + bodyW / 2} y={bodyY + bodyH * 0.4 + 4}
                    textAnchor="middle" fill="#F1F5F9" fontSize={9} fontWeight="bold">
                    {isNaN(pressureVal) ? '--' : pressureVal.toFixed(1)} bar
                </text>
            )}
            {tempBound && (
                <text x={bodyX + bodyW / 2} y={bodyY + bodyH * 0.65 + 4}
                    textAnchor="middle" fill="#FCD34D" fontSize={9} fontWeight="bold">
                    {isNaN(tempVal) ? '--' : tempVal.toFixed(0)}°C
                </text>
            )}

            {/* Status dot */}
            <circle cx={bodyX + bodyW - 7} cy={bodyY + 8} r={4}
                fill={statusColor} stroke="#0F172A" strokeWidth={1} />

            {/* Firebox at bottom */}
            <rect x={bodyX + 4} y={bodyY + bodyH - 2} width={bodyW - 8} height={14}
                rx={3} fill="#0F172A" stroke={flameColor} strokeWidth={1.5} />

            {/* Flame triangles */}
            <polygon points={`${bodyX + 10},${bodyY + bodyH + 12} ${bodyX + 16},${bodyY + bodyH - 2} ${bodyX + 22},${bodyY + bodyH + 12}`}
                fill={flameColor} opacity={running ? 0.9 : 0.3} />
            <polygon points={`${bodyX + 18},${bodyY + bodyH + 12} ${bodyX + 24},${bodyY + bodyH - 2} ${bodyX + 30},${bodyY + bodyH + 12}`}
                fill={flameInner} opacity={running ? 0.8 : 0.2} />
            {bodyW > 32 && (
                <polygon points={`${bodyX + bodyW - 26},${bodyY + bodyH + 12} ${bodyX + bodyW - 20},${bodyY + bodyH - 2} ${bodyX + bodyW - 14},${bodyY + bodyH + 12}`}
                    fill={flameColor} opacity={running ? 0.9 : 0.3} />
            )}

            {/* Water inlet stub at bottom */}
            <rect x={bodyX + bodyW / 2 - 4} y={height - 4} width={8} height={4} rx={1} fill="#475569" />

            {/* Fuel inlet stub on left */}
            <rect x={0} y={bodyY + bodyH * 0.7} width={bodyX} height={5} rx={1} fill="#475569" />
        </svg>
    );
}

export default function BoilerNode(props) {
    const { data } = props;
    const w = data?.width || 70;
    const h = data?.height || 100;
    return (
        <BaseScadaNode {...props}>
            <BoilerSVG config={data?.config} width={w} height={h} liveValues={data?.liveValues || {}} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', marginTop: 2,
                    overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
